import * as angular from "angular";
import * as _ from "lodash";
import {IRootScopeService} from "angular";
import {IAMPermissionsService} from "../../../permission/iamPermissions.service";
import {ResourcesService} from "../../resources/services/resources-service.service";
import {kml} from '@tmcw/togeojson';

export class ServiceAreaDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $serviceArea, private $rootScope: IRootScopeService, private ServiceAreaConstants,
              private $log, private $translate, private IAMPermissions: IAMPermissionsService) {
  }

  // ******************************
  // External methods
  // ******************************

  edit(event, serviceArea) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/edit-service-area-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.serviceArea = angular.copy(serviceArea);

        $scope.rePrice = false;
        $scope.submitClicked = false;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {

              if (_.isEqual($scope.serviceArea, serviceArea)) {
                self.$mdDialog.hide();
              }
              $scope.doUpdate();
            }

          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> serviceAreaDialogService@edit@submit')
          }
        }

        $scope.doUpdate = () => {
          $scope.submitClicked = true;
          self.$serviceArea(serviceArea.areaId).$update($scope.serviceArea, {}, {rePrice: $scope.rePrice})
            .then(() => {
              self.$rootScope.$broadcast(self.ServiceAreaConstants.events.areaUpdated, serviceArea.areaId);
            })
            .catch((error) => {
              self.$log.debug(error);
            });
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  savePolygonChanges(event) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/save-polygon-changes-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.text = self.$translate.instant('Are you sure you want to save changes to service area?');
        $scope.header = self.$translate.instant('Save');

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////

        $scope.submit = () => {
          self.$mdDialog.hide(true);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  saveAndRepricePolygonChanges(event) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/save-polygon-changes-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.header = self.$translate.instant('Save And Reprice');
        $scope.text = self.$translate.instant('you are going save the polygon changes and reprice this service area and all associated');

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////

        $scope.submit = () => {
          self.$mdDialog.hide(true);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }


  addServiceArea(event, branchId, serviceAreasList, selectedAreaIds) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/add-service-areas-dialog.html').default,
      parent: angular.element(document.body),
      controller: function ($scope, $timeout, resourcesService, bringozToastService) {

        $scope.branchId = angular.copy(branchId);
        $scope.serviceAreasList = serviceAreasList;
        $scope.selectedAreaIds = angular.copy(selectedAreaIds);

        $scope.addedAreasResources = [];
        $scope.removedAreasResources = [];
        $scope.loadingResources = false;


        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////

        $scope.copyResources = (resourcesNames) => {
          window.navigator.clipboard.writeText(resourcesNames).then(() => {
            const message = {
              body: 'TEXT_COPIED_TO_CLIPBOARD'
            };
            bringozToastService.success(message);
          });
        }

        $scope.onSelectChange = (areaIds) => {
          $scope.selectedAreaIds = areaIds;
          $scope._getConnectedResourcesByServiceAreas();
        }

        $scope.submit = () => {
          var selectedAreas = _.filter(serviceAreasList, (area) => {
            return _.indexOf($scope.selectedAreaIds, area.areaId) !== -1;
          });
          self.$mdDialog.hide(selectedAreas);
        }

        $scope._getConnectedResourcesByServiceAreas = () => {
          if (!$scope.loadingResources && !!$scope.branchId && self.IAMPermissions.hasPermission('supplyResources.list')) {

            $timeout(2000).then(() => {
              const addedServiceAreasIds = _.difference($scope.selectedAreaIds, selectedAreaIds);
              const removedServiceAreasIds = _.difference(selectedAreaIds, $scope.selectedAreaIds);

              if (addedServiceAreasIds.length || removedServiceAreasIds.length) {
                $scope.loadingResources = true;
                resourcesService.getConnectedResourcesByServiceAreas($scope.branchId, addedServiceAreasIds, removedServiceAreasIds)
                  .then((res) => {
                    $scope.addedAreasResources = res.addedAreasResources;
                    $scope.removedAreasResources = res.removedAreasResources;
                  })
                  .finally(() => {
                    $scope.loadingResources = false;
                  })

              } else {
                $scope.addedAreasResources = [];
                $scope.removedAreasResources = [];
              }

            })

          }

        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    });
  }

  uploadGeoJSON(event, feature) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/upload-geo-json.html').default,
      parent: angular.element(document.body),
      controller: function ($scope, $timeout) {

        $scope.siteIdRef = _.get(feature, 'properties.siteId');
        $scope.areaIdRef = _.get(feature, 'properties.areaId');
        $scope.branchIdsIdRef = _.get(feature, 'properties.branchIds');

        _.unset(feature, 'properties.siteId');
        _.unset(feature, 'properties.areaId');
        _.unset(feature, 'properties.branchIds');

        $scope.geoJSON = feature ? JSON.stringify(feature) : undefined;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.kmlFile = undefined;
        /////////////////////////

        $scope.onFileUpload = (event) => {
          const fileInput = event.target as HTMLInputElement;

          if (fileInput.files && fileInput.files.length > 0) {
            const file = fileInput.files[0];

            // Read the file as text
            const reader = new FileReader();
            reader.onload = (e) => {
              const fileContent = e.target?.result as string;

              // Parse the KML into a DOM object
              const parser = new DOMParser();
              const kmlDom = parser.parseFromString(fileContent, 'application/xml');

              // Convert the KML to GeoJSON
              const geojson = kml(kmlDom);

              // Convert GeoJSON object to a string
              // FIXME since we currently only support one single feature in console and the library create feature collection so we take the first feature
              if (geojson.type === "FeatureCollection" && geojson.features?.length > 0) {
                const firstFeature = geojson.features[0]; // Get the first feature
                // Convert the first feature to a string
                $scope.geoJSON = JSON.stringify(firstFeature, null, 2);
              } else {
                // Handle cases where there are no features
                $scope.geoJSON = JSON.stringify(geojson, null, 2);
              }

              $timeout(() => {
              }, 0);
            };

            reader.readAsText(file); // Trigger file reading
          }
        }

        $timeout(() => {
          const fileUploadInput = document.getElementById('file-upload');
          fileUploadInput.addEventListener('change', (e) => {
            $scope.onFileUpload(e);
          })
        }, 0)

        $scope.submit = () => {
          const geoJson = JSON.parse($scope.geoJSON);

          if ($scope.siteIdRef) {
            _.set(geoJson, 'properties.siteId', $scope.siteIdRef);
          }
          if ($scope.areaIdRef) {
            _.set(geoJson, 'properties.areaId', $scope.areaIdRef);
          }
          if ($scope.branchIdsIdRef) {
            _.set(geoJson, 'properties.branchIds', $scope.branchIdsIdRef);
          }

          self.$mdDialog.hide(geoJson);
        }
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.service-areas')
  .service('serviceAreaDialogService', ServiceAreaDialogService);
